;(function ($) {

	$(document).ready(function(){
        //design lines white bkgd
        if ($('.hero').hasClass('bg-white') || $('.hero').hasClass('no-bkgd')) {
            $('#design-line-1, #design-line-2, #design-line-3').addClass('light');
        }
        $('.open-podcast').click(function(e){
            e.preventDefault();
            var iframe_data = jQuery(this).data('id');
            var iframe_url = '/wp-content/themes/cmac/setup/Podcast.php?id=' + iframe_data;
            window.open(iframe_url,null, 'width=700,height=120');
        });
        $('.fancybox.fancybox-video').fancybox({
            type: "iframe"
        });

        //save popup cookie
		$('#close-popup').click(function(){
			//Cookies.set('cmac-popup', 'disabled', { expires: 1 });
			$('.popup').fadeOut();
		});
		$('.popup .content a').click(function(){
			//Cookies.set('cmac-popup', 'disabled', { expires: 1 });
        });
        
        checkFRED();
	});

    function checkFRED(){
        console.log('checking FRED');
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                "action": "checking_fred"
            },
            beforeSend : function() {
                //do something
            },
            success: function(response) {
                //console.log(response);
                var res = JSON.parse(response);
                console.log(res);
            }    
        });
    }

	$(window).load(function(){
        //design lines
        $('#design-line-1').addClass('grow');
        $('#design-line-2').addClass('grow-2');
        $('#design-line-3').addClass('grow-3');

		// Only animate elems above the fold. Everything else animate on scroll
        $('.anim-load').addClass('anim-complete');
        $('.fade-load').addClass('fade-complete');
        $('.line-load').addClass('line-complete');

        //check for popup
        var popup = Cookies.get('cmac-popup');
        if (popup) {
            $('.popup').removeClass('reveal');
        } else {
            setTimeout(openPopup, 4000);
        }
    });
    
    function openPopup(){
        $('.popup').addClass('reveal');
    }

    $(window).scroll(function() {

        $('.anim-up, .anim-left, .anim-right, .anim-far-left, .anim-far-right').each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
            el.addClass('anim-complete'); 
            }
        });
        $('.anim-reveal-down').each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
            el.addClass('anim-reveal-up'); 
            }
        });
        $('.anim-reveal-left').each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
            el.addClass('anim-reveal-right'); 
            }
        });
        $('.fade-in').each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
            el.addClass('fade-complete'); 
            }
        });
        $('.line-grow').each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
            el.addClass('line-complete'); 
            }
        });
        $('.line-grow-med').each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
            el.addClass('line-complete-med'); 
            }
        });
    });

	$(window).resize(function(){


	});

	$.fn.visible = function(partial) {


        var $t        = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };
    $('iframe[src*="youtube"]').wrap("<div class='video-container'></div>");


})(jQuery);